import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getEmailCampaign, saveEmailCampaign, getEmailCampaignCounts } from "services/emailcampaigns";
import { BackLink, Button, CancelButton, PageTitle, PageHeader } from "../../components/StyledElements";
import { EmailCampaignSidebar } from "./emailcampaign/EmailCampaignSidebar";
import { CoreDetails } from "./emailcampaign/CoreDetails";
import { Recipients } from "./emailcampaign/Recipients";

const EmailCampaign = () => {
  const [saving, setSaving] = useState(false);
  const { email_campaign_id } = useParams();
  const [emailCampaign, setEmailCampaign] = useState({
    title: "",
    description: "",
    recipients: [],
  });
  const [updatedEmailCampaign, setUpdatedEmailCampaign] = useState(emailCampaign);
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "details");
  const [emailCampaignCounts, setEmailCampaignCounts] = useState(null);
  const navigate = useNavigate();



  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("STATE: ", location);
  }, [location]);

  useEffect(() => {
    const fetchEmailCampaign = async () => {
      const result = await getEmailCampaign(email_campaign_id);
      if (result.success) {
        setEmailCampaign(result.email_campaign);
        setUpdatedEmailCampaign(result.email_campaign);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.message,
        });
      }

      const countsResult = await getEmailCampaignCounts(email_campaign_id);
      if (countsResult.success) {
        setEmailCampaignCounts(countsResult.counts);
      }
    }

    if (email_campaign_id) {
      fetchEmailCampaign();
    }

    return () => {
      setEmailCampaign(null);
    };
    // eslint-disable-next-line
  }, [email_campaign_id]);

  useEffect(() => {
    if (emailCampaign && emailCampaignCounts) {
      if (emailCampaignCounts.pending > 0) {
        setTimeout(() => {
          const fetchEmailCampaignCounts = async () => {
            const countsResult = await getEmailCampaignCounts(email_campaign_id);
            if (countsResult.success) {
              setEmailCampaignCounts(countsResult.counts);
            }
          }
          fetchEmailCampaignCounts();
        }, 5000);
      }
    }

    // eslint-disable-next-line
  }, [emailCampaignCounts]);

  const save = async () => {
    console.log("save email campaign: ", updatedEmailCampaign);
    setSaving(true);
    const results = await saveEmailCampaign(updatedEmailCampaign);
    if (results.success) {
      const emailCampaign = results.emailcampaign;
      Swal.fire({
        icon: "success",
        title: "Success",
        text: results.message,
      });
      //window.location.replace(`/admin/email-campaigns/${emailCampaign.public_id}`);
      setEmailCampaign(emailCampaign);
      setUpdatedEmailCampaign(emailCampaign);
    } else {
      console.log("Error saving email campaign: ", results.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: results.message,
      });
    }
    setSaving(false);
  };

  const canSaveEmailCampaign = () => {
    return (
      updatedEmailCampaign?.title !== "" && JSON.stringify(emailCampaign) !== JSON.stringify(updatedEmailCampaign)
    );
  };

  console.log("!!! RENDERING, emailCampaign: ", emailCampaign, "updatedEmailCampaign: ", updatedEmailCampaign);

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>
      <div style={{ width: "250px" }}>
        <EmailCampaignSidebar
          emailCampaignId={emailCampaign?.public_id}
          defaultSelectedTab={selectedTab}
          onNavItemClicked={(navItem) => {
            console.log("!!! NAV ITEM CLICKED: ", navItem);
            setSelectedTab(navItem);
          }}
        />
      </div>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - 250px)`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          backgroundColor: "var(--content-item-bg)",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 2000,
          /*height: "2000px",*/
        }}
      >
        <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <div>
            <BackLink onClick={() => {
              navigate(`/admin/email-campaigns`);
            }} >
              <i className="fa fa-arrow-left" /> Back to Email Campaigns</BackLink>
            <PageTitle title={`${emailCampaign?.id ? "Edit" : "New"} Email Campaign`} style={{ marginBottom: "0px" }} />
            {emailCampaign?.title ?
              <PageTitle title={emailCampaign?.title} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px" }} />
              : null}
          </div>
          <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
            <CancelButton onClick={() => {
              setEmailCampaign(emailCampaign);
            }}>Cancel</CancelButton>
            <Button disabled={!canSaveEmailCampaign() || saving} onClick={save} style={{ marginLeft: "auto" }}>{saving ? "Saving Changes" : "Save Changes"}</Button>
          </div>
        </PageHeader>
        <PageHeader >
          {
            emailCampaignCounts ? (
              <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                <div>Pending: {emailCampaignCounts.pending}</div>
                <div>Processing: {emailCampaignCounts.processing}</div>
                <div>Sent: {emailCampaignCounts.sent}</div>
                <div>Failed: {emailCampaignCounts.failed}</div>
                <div>Total: {emailCampaignCounts.total_recipients}</div>
                <div>Percentage Sent: {emailCampaignCounts.percentage_sent}%</div>
              </div>
            ) : (
              <div style={{ fontStyle: "italic", color: "var(--main-font-color-light)" }}>Loading stats...</div>
            )
          }
        </PageHeader>
        <div style={{ backgroundColor: "var(--content-item-bg)", marginTop: "20px", marginBottom: "40px", position: "relative", zIndex: 2000 }}>
          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%" }}>
              <CoreDetails
                style={{ display: selectedTab === "details" ? "flex" : "none" }}
                emailCampaign={updatedEmailCampaign}
                onChange={(ec) => {
                  console.log("!!! CORE DETAILS CHANGED: ", ec);
                  setUpdatedEmailCampaign({ ...ec });
                }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <Recipients style={{ display: selectedTab === "recipients" ? "flex" : "none" }}
                emailCampaign={updatedEmailCampaign}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailCampaign;
